export const NODE_CONFIG_FIELDS = {
  trigger_webhook: [],
  trigger_schedule: [
    { key: 'interval', label: 'Run Every', type: 'text', placeholder: '30' },
    { key: 'unit', label: 'Unit', type: 'select', options: ['minutes', 'hours', 'days'] },
  ],
  trigger_manual: [
    { key: 'note', label: 'Description', type: 'textarea', placeholder: 'Describe when to run this manually...' },
  ],
  trigger_wallettwo: [
    { key: 'event', label: 'Event', type: 'select', options: [
      { value: 'userRegistered', label: 'User Registered' },
      { value: 'userLoggedIn', label: 'User Logged In' },
      { value: 'walletCreated', label: 'Wallet Created' },
      { value: 'walletRecovered', label: 'Wallet Recovered' },
      { value: 'userJoinedCompany', label: 'User Joined Company' },
      { value: 'transactionSponsored', label: 'Transaction Sponsored' },
      { value: 'rampSessionCompleted', label: 'Ramp Session Completed' },
      { value: 'rwaClaimed', label: 'RWA Claimed' },
      { value: 'rwaBought', label: 'RWA Bought' },
      { value: 'tokenClaimed', label: 'Token Claimed' },
      { value: 'tokenBought', label: 'Token Bought' },
      { value: 'userJoinedEvent', label: 'User Joined Event' },
    ] },
  ],
  trigger_onchain: [
    { key: 'network', label: 'Network', type: 'network_select' },
    { key: 'contractAddress', label: 'Contract', type: 'token_select' },
    { key: 'eventName', label: 'Event Name', type: 'text', placeholder: 'Transfer' },
  ],
  action_slack: [
    { key: 'webhookUrl', label: 'Webhook URL', type: 'text', placeholder: 'https://hooks.slack.com/services/...' },
    { key: 'messageMode', label: 'Message Mode', type: 'select', options: [
      { value: 'text', label: 'Plain Text' },
      { value: 'blocks', label: 'Blocks' },
      { value: 'raw', label: 'Raw JSON' },
    ] },
    { key: 'message', label: 'Message', type: 'textarea', placeholder: 'Hello from workflow!' },
    { key: 'blocks', label: 'Blocks', type: 'slack_blocks' },
    { key: 'rawJson', label: 'Block Kit JSON', type: 'slack_raw_json' },
  ],
  action_telegram: [
    { key: 'botToken', label: 'Bot Token', type: 'password', placeholder: 'Your bot token' },
    { key: 'chatId', label: 'Chat ID', type: 'text', placeholder: '-1001234567890' },
    { key: 'message', label: 'Message', type: 'textarea', placeholder: 'Message text...' },
  ],
  action_sendgrid: [
    { key: 'apiKey', label: 'API Key', type: 'password', placeholder: 'SG.xxxxxxxxxxxx' },
    { key: 'to', label: 'To', type: 'text', placeholder: 'recipient@example.com' },
    { key: 'from', label: 'From', type: 'text', placeholder: 'noreply@yourcompany.com' },
    { key: 'subject', label: 'Subject', type: 'text', placeholder: 'Email subject' },
    { key: 'contentType', label: 'Content Type', type: 'select', options: [
      { value: 'html', label: 'HTML' },
      { value: 'text', label: 'Text' },
      { value: 'template', label: 'Dynamic Template' },
    ] },
  ],
  wallet_load: [
    { key: 'walletLabel', label: 'Wallet Label', type: 'text', placeholder: 'My Wallet' },
    { key: 'inputType', label: 'Import Method', type: 'select', options: ['Private Key', 'Mnemonic'] },
    { key: 'value', label: 'Private Key / Mnemonic', type: 'password', placeholder: 'Enter private key or mnemonic phrase...' },
    { key: 'network', label: 'Network', type: 'network_select' },
  ],
  wallet_transfer: [
    { key: 'walletRef', label: 'Source Wallet', type: 'wallet_select', placeholder: 'Select loaded wallet' },
    { key: 'toAddress', label: 'To Address', type: 'text', placeholder: '0x...' },
    { key: 'amount', label: 'Amount', type: 'text', placeholder: '0.1' },
    { key: 'token', label: 'Token', type: 'token_select' },
  ],
  wallet_balance: [
    { key: 'walletRef', label: 'Wallet', type: 'wallet_select', placeholder: 'Select loaded wallet' },
    { key: 'token', label: 'Token', type: 'token_select' },
  ],
  wallet_sign: [
    { key: 'walletRef', label: 'Wallet', type: 'wallet_select', placeholder: 'Select loaded wallet' },
    { key: 'message', label: 'Message', type: 'textarea', placeholder: 'Message to sign...' },
  ],
  wallettwo_get_member: [
    { key: 'filterField', label: 'Filter By', type: 'select', options: ['Email', 'Name', 'Wallet Address', 'ID', 'Role'] },
    { key: 'filterValue', label: 'Filter Value', type: 'text', placeholder: 'e.g. john@example.com' },
  ],
  wallettwo_get_members: [
    { key: 'filterField', label: 'Filter By', type: 'select', options: ['All', 'Role', 'Status', 'Registration Date', 'KYC Status'] },
    { key: 'filterOperator', label: 'Operator', type: 'select', options: ['equals', 'not equals', 'contains', 'starts with', 'greater than', 'less than'] },
    { key: 'filterValue', label: 'Filter Value', type: 'text', placeholder: 'Filter value...' },
    { key: 'sortBy', label: 'Sort By', type: 'select', options: ['Name', 'Email', 'Created Date', 'Last Active'] },
    { key: 'sortOrder', label: 'Sort Order', type: 'select', options: ['Ascending', 'Descending'] },
    { key: 'limit', label: 'Limit', type: 'text', placeholder: 'Max number of results (e.g. 100)' },
  ],
  logic_foreach: [
    { key: 'collectionRef', label: 'Collection Source', type: 'node_select', placeholder: 'Select node that outputs a list' },
    { key: 'itemVariable', label: 'Item Variable Name', type: 'text', placeholder: 'item' },
  ],
  logic_condition: [
    { key: 'leftOperand', label: 'Value', type: 'text', placeholder: '{{previous.output}}' },
    { key: 'operator', label: 'Operator', type: 'select', options: ['equals', 'not equals', 'greater than', 'less than', 'contains', 'is empty', 'is not empty'] },
    { key: 'rightOperand', label: 'Compare With', type: 'text', placeholder: 'expected value' },
  ],
  logic_delay: [
    { key: 'duration', label: 'Duration', type: 'text', placeholder: '5' },
    { key: 'unit', label: 'Unit', type: 'select', options: ['seconds', 'minutes', 'hours'] },
  ],
};

// Per-event configuration fields for WalletTwo Event trigger
export const WALLETTWO_EVENT_FIELDS = {
  userRegistered: [],
  userLoggedIn: [],
  walletCreated: [],
  walletRecovered: [],
  userJoinedCompany: [],
  transactionSponsored: [
    { key: 'network', label: 'Network', type: 'network_select' },
    { key: 'contractAddress', label: 'Contract', type: 'token_select' },
  ],
  rampSessionCompleted: [
    /*{ key: 'network', label: 'Network', type: 'network_select' },
    { key: 'token', label: 'Token', type: 'token_select' },
    { key: 'currency', label: 'Currency', type: 'text', placeholder: 'e.g. EUR, USD (optional)' },
    { key: 'minAmount', label: 'Min Amount', type: 'text', placeholder: 'e.g. 100 (optional)' },*/
  ],
  rwaClaimed: [
    { key: 'rwaId', label: 'RWA ID', type: 'text', placeholder: 'Specific RWA ID (optional)' },
  ],
  rwaBought: [
    { key: 'rwaId', label: 'RWA ID', type: 'text', placeholder: 'Specific RWA ID (optional)' },
  ],
  tokenClaimed: [
    { key: 'tokenId', label: 'Token ID', type: 'text', placeholder: 'Specific Token ID (optional)' },
  ],
  tokenBought: [
    { key: 'tokenId', label: 'Token ID', type: 'text', placeholder: 'Specific Token ID (optional)' },
    { key: 'minAmount', label: 'Min Amount', type: 'text', placeholder: 'e.g. 10' },
  ],
  userJoinedEvent: [
    { key: 'eventId', label: 'Event ID', type: 'text', placeholder: 'Specific Event ID (optional)' },
  ],
};
